import { Briefcase, AlertTriangle, Clock } from "lucide-react";
import { Card } from "@/components/ui/card";

const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("pt-BR", { day: "2-digit", month: "short" });
  } catch {
    return "—";
  }
};

const labelDaysUntil = (d) => {
  if (d == null) return "sem prazo";
  if (d < 0) return `${Math.abs(d)}d atrás`;
  if (d === 0) return "hoje";
  if (d === 1) return "amanhã";
  return `em ${d}d`;
};

/**
 * ProjectStatusCard — overview de projetos ativos do user.
 * Renderiza payload de backend build_project_status.
 */
export default function ProjectStatusCard({ data }) {
  const total = data?.total_active ?? 0;
  const overdue = data?.overdue_count ?? 0;
  const soon = data?.soon_count ?? 0;
  const top = data?.top_5 || [];

  return (
    <Card variant="elevated" className="p-4 max-w-md">
      <div className="text-xs text-foreground-muted mb-2">Seus projetos</div>

      <div className="grid grid-cols-3 gap-2 mb-3">
        <div className="flex flex-col items-center gap-1 py-2 px-3 rounded-lg bg-surface-card-hover">
          <Briefcase className="w-4 h-4 text-indigo-400" />
          <div className="text-lg font-bold text-foreground leading-none">{total}</div>
          <div className="text-[10px] text-foreground-muted text-center">Ativos</div>
        </div>
        <div className="flex flex-col items-center gap-1 py-2 px-3 rounded-lg bg-surface-card-hover">
          <AlertTriangle className="w-4 h-4 text-red-400" />
          <div className="text-lg font-bold text-foreground leading-none">{overdue}</div>
          <div className="text-[10px] text-foreground-muted text-center">Atrasados</div>
        </div>
        <div className="flex flex-col items-center gap-1 py-2 px-3 rounded-lg bg-surface-card-hover">
          <Clock className="w-4 h-4 text-amber-400" />
          <div className="text-lg font-bold text-foreground leading-none">{soon}</div>
          <div className="text-[10px] text-foreground-muted text-center">Em até 7d</div>
        </div>
      </div>

      {top.length > 0 && (
        <div className="space-y-1">
          <div className="text-[10px] text-foreground-muted uppercase tracking-wider mb-1">
            Em destaque
          </div>
          {top.slice(0, 5).map((p) => {
            const urgent = p.days_until != null && p.days_until <= 7;
            return (
              <div
                key={p.id}
                className="flex items-center justify-between py-1.5 px-3 rounded-lg bg-surface-card-hover"
              >
                <div className="min-w-0 mr-2">
                  <div className="text-xs text-foreground truncate">{p.title}</div>
                </div>
                <div
                  className={`text-[10px] whitespace-nowrap ${
                    urgent ? "text-amber-400" : "text-foreground-muted"
                  }`}
                >
                  {p.end_date ? `${labelDaysUntil(p.days_until)} (${fmtDate(p.end_date)})` : "sem prazo"}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </Card>
  );
}
